import React from "react";
import styles from "./tagsCell.module.scss";

interface TagsCellProps {
  tags?: string[];
}


const TagsCell: React.FunctionComponent<TagsCellProps> = ({tags}) => {
  return (
    <div className={styles.tagsContainer}>
      {tags?.map((tag: string, i: number) => {
        return (
          <div className={styles.tag} key={i}>
            {tag}
          </div>
        );
      })}
    </div>
  );
};

export default TagsCell;